import { CommandType } from '../constants/Constants';
import UndoManager from '../manager/UndoManager';
import BaseCommand from './BaseCommand';

/**
 * Redo
 *
 * @export
 * @class CmdRedo
 * @extends {BaseCommand}
 * @author zhenliang.sun
 */
export default class CmdRedo extends BaseCommand {
  constructor() {
    super();
    this.executing = false;
    this.type = CommandType.Redo;
  }

  execute() {
    super.execute();
    this.app.items.redo();
  }
}
